import { type FC, type ReactNode } from 'react';

import { stepInteractionConstants } from 'dibs-tracking';
import { BuyerIncentivesBanner } from 'dibs-buyer-incentives/exports/BuyerIncentivesBanner.ts';

import { getPurchaseProtectionLink } from '../../helpers/purchaseProtectionLink.tsx';

const PdpSharedSidebarBuyerIncentives: FC = () => {
    const getLink = (chunk: ReactNode): ReactNode =>
        getPurchaseProtectionLink(
            stepInteractionConstants.STEP_INTERACTION_EBI_SIDERAIL_DETAILS_CLICK,
            'dibs-promise-link'
        )(chunk);

    return <BuyerIncentivesBanner getLink={getLink} />;
};

export default PdpSharedSidebarBuyerIncentives;
